import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex font-montserrat flex-col justify-center items-center" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "lg:h-[80px] h-[50px]" }, null, -1)
const _hoisted_4 = { class: "absolute z-[1000000] text-left bg-black/50 px-[20px] md:px-[50px] text-white top-0 left-0 right-0 bottom-0 w-full flex items-center flex-col justify-center" }
const _hoisted_5 = { class: "text-4xl md:text-6xl uppercase text-center font-bold opacity-100" }
const _hoisted_6 = { class: "container max-w-[1024px]" }
const _hoisted_7 = { class: "w-full relative flex justify-center items-center md:mt-[50px] mt-[20px]" }
const _hoisted_8 = { class: "container relative w-full md:my-[50px] my-[20px]" }
const _hoisted_9 = { class: "text-2xl my-[20px] font-bold text-center text-cyan-700 uppercase" }
const _hoisted_10 = { class: "w-full flex relative" }

import HeaderComponent from '../components/HeaderComponent.vue'
  import carouselBranding from '../components/CarouselBranding.vue'
  import One_trainings from '@/components/One_trainings.vue';
  import { ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
import FooterComponent from '@/components/FooterComponent.vue';
  const initialSlide = 1;
  
export default /*#__PURE__*/_defineComponent({
  __name: 'trainingFS',
  setup(__props) {

  const router = useRouter()
  
  function goToTrainingSPage() {
      router.push('/trainingFS')
  }
  function goToTrainingCPage() {
      router.push('/trainingFC')
  }
  function goToTrainingPage() {
      router.push('/training')
  }
  const pageTitle = ref('IronSecur | Training'); 
  
  onMounted(() => {
      document.title = pageTitle.value; 
  });
  
  const trainings = ref([
  
    {   nam: 't2_nam', 
        style: "md:leading-10",
        target: 't2_target', 
        pre: 't2_pre', 
        edu: ["t2_edu1", "t2_edu2", "t2_edu3", "t2_edu4", "t2_edu5", "t2_edu6", "t2_edu7"], 
        image: "/img/training2.jpg", 
        booklet: '#', 
        PA: ["t2_PA1", "t2_PA2", "t2_PA3", "t2_PA4"], 
        Duration: ["t2_Duration1", "t2_Duration2", "t2_Duration3", "t2_Duration4"], 
        PR: ["t2_PR1", "t2_PR2", "t2_PR3", "t2_PR4", "t2_PR5"] 
    },

    {   nam: 't3_nam', 
        target: 't3_target', 
        pre: 't3_pre', 
        edu: ["t3_edu1", "t3_edu2", "t3_edu3", "t3_edu4", "t3_edu5", "t3_edu6", "t3_edu7"], 
        image: "/img/training6.jpg", 
        booklet: '#', 
        PA: ["t3_PA1", "t3_PA2", "t3_PA3", "t3_PA4"], 
        Duration: ["t3_Duration1", "t3_Duration2", "t3_Duration3", "t3_Duration4"], 
        PR: ["t3_PR1", "t3_PR2", "t3_PR3", "t3_PR4", "t3_PR5"] 
    },

  ]);
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(carouselBranding, { "initial-slide": initialSlide }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('training')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.$t('training')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", {
              onClick: goToTrainingPage,
              class: _normalizeClass({
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  ' border-cyan-700': _ctx.$route.path === '/training'
              })
            }, _toDisplayString(_ctx.$t('FD')), 3),
            _createElementVNode("span", {
              onClick: goToTrainingSPage,
              class: _normalizeClass({
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  ' border-cyan-700': _ctx.$route.path === '/trainingFS'
              })
            }, _toDisplayString(_ctx.$t('FS')), 3),
            _createElementVNode("span", {
              onClick: goToTrainingCPage,
              class: _normalizeClass({
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  ' border-cyan-700': _ctx.$route.path === '/trainingFC'
              })
            }, _toDisplayString(_ctx.$t('FC')), 3)
          ]),
          _createVNode(One_trainings, { trainings: trainings.value }, null, 8, ["trainings"])
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ]))
}
}

})